import { TitleCasePipe } from '@angular/common';

const TITLE_CASE = new TitleCasePipe();

export const isCasheaBill = (bill: any): boolean => !!bill?.casheaOrderId;

/** Las facturas de Cashea anteriores a `casheaOrderKind` son todas del QR. */
export const casheaBillLabel = (bill: any): string => (bill?.casheaOrderKind === 'LINK' ? 'Cashea Link' : 'Cashea QR');

/** En una venta con Cashea, la cuenta por cobrar es lo que financia Cashea: se nombra por su origen. */
export const billPaymentMethodLabel = (bill: any, pm: any): string => (isCasheaBill(bill) && pm?.name === 'CUENTA POR COBRAR' ? casheaBillLabel(bill) : TITLE_CASE.transform(pm?.name ?? ''));

/** Una venta 100% inicial no tiene cuenta por cobrar donde mostrar el origen: va aparte. */
export const needsSeparateCasheaLabel = (bill: any): boolean => isCasheaBill(bill) && !(bill?.paymentMethods || []).some((pm: any) => pm?.name === 'CUENTA POR COBRAR');
